export default "/assets/font_family_roboto-c2e1430baa61d8a5fa6c29e11dfd554c9a5d0e275fd521f2be3c642ea45ce3fd.svg";